export default __webpack_public_path__ + "static/separateparts-3d3ac09536c9c9ca36bf5d38b66c9728.png";